import { ActivatedRoute, Router } from '@angular/router';
import { Component, OnInit, ViewChild, Output, EventEmitter, Input } from '@angular/core';
import { NgScrollbar } from 'ngx-scrollbar';
import { MapInfoWindow, MapMarker } from '@angular/google-maps';
import { MapService } from './service/map.service';
import { slideDownUp } from '../../shared/animations';
import { GeolocationService } from '../../shared/service/geolocation/geolocation.service';
import { AuthService } from './../../shared/service/auth/auth.service';
import { WorkShopDTO } from './../../shared/dto/work-shop.dto';
import { CoordinatesDTO } from './../../shared/dto/common.dto';
import { CommonService } from './../../shared/service/common/common.service';
import { UserIconPositionConst, MapOptionsConstants, WorkShopIconPositionFilteredConst } from './../../shared/constants/common.constants';
import { AnalitycsService } from 'src/app/shared/service/analitycs.service';

@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrl: './map.component.css',
  animations: [slideDownUp],
})
export class MapComponent implements OnInit {
  @ViewChild('scrollable') scrollable!: NgScrollbar;
  @ViewChild(MapInfoWindow, { static: false }) infoWindow: MapInfoWindow | undefined;

  @Output() assistantSchedule = new EventEmitter<any>();
  @Output() workshopsUpdated = new EventEmitter<void>();
  @Input() mapWidth: string = '200%'; // Ancho predeterminado
  @Input() mapHeight: string = '100%'; // Alto predeterminado
  @Input() coordinates: CoordinatesDTO = { lat: 0, lng: 0 };
  @Input() set workshopsFromAssistant(value: WorkShopDTO[]) {
    if (value && value.length > 0) {
      this.updateWorkshops(value);
    }
  }

  coords: CoordinatesDTO = { lat: 0, lng: 0 };
  loadingMap: boolean = false;
  workshops: WorkShopDTO[] = [];
  selectedWorkshop: WorkShopDTO | undefined;
  userCoordinates: CoordinatesDTO = { lat: 0, lng: 0 };
  userIconPosition = UserIconPositionConst;
  //   workShopIconPosition = WorkShopIconPositionConst;
  mapOptions = MapOptionsConstants;
  isMobile: boolean = false;
  showMap: boolean = true;
  textMessage: string = '';
  loadingConversation: boolean = false;
  store: any;
  assistantSection: boolean = false;

  constructor(
    private router: Router,
    private geolocationService: GeolocationService,
    public mapService: MapService,
    private auth: AuthService,
    private readonly commonService: CommonService,
    private route: ActivatedRoute,
    private analitycs: AnalitycsService,
  ) {
    this.workshops = [];
    if (window.innerWidth < 768) {
      this.isMobile = false;
      this.mapWidth = '100%';
    }
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const lat = Number(params['lat']);
      const lng = Number(params['lng']);

      if (!isNaN(lat) && !isNaN(lng)) {
        this.coordinates = { lat, lng };
      } else {
        // console.error('Los parámetros no son números válidos.');
      }
    });
    this.getAvailableServiceCenters();
    this.getLocation();
    this.mapService.showMap$.subscribe((value) => {
      this.showMap = !value;
    });
    this.initStore();
  }

  async initStore() {
    // todo: prepare the store
  }

  // Get the workshops
  async getAvailableServiceCenters() {
    const response = await this.commonService.getAvailableServiceCenters();
    this.commonService.getAvailableCountriesToCmb();
    this.commonService.getAvailableStatesByCountryCode('CO');
    this.commonService.getAvailableCityByStateCountryCode('CO', '05');
    if (response && response.length > 0) {
      this.workshops = response;
      for (const i in this.workshops) {
        this.workshops[i].coords = {
          lat: this.workshops[i].gpsLocation.coordinates[1],
          lng: this.workshops[i].gpsLocation.coordinates[0],
        };
        this.workshops[i].icon = {
          url: this.workshops[i].icon,
          scaledSize: {
            width: 50,
            height: 50,
          },
        };
      }
    }
  }

  async getLocation() {
    this.loadingMap = true;
    const location = await this.geolocationService.getCurrentLocation();
    if (location) {
      this.coords = {
        lat: location.coords.latitude,
        lng: location.coords.longitude,
      };
      this.loadingMap = false;
    } else {
      this.coords = {
        lat: this.coordinates.lat,
        lng: this.coordinates.lng,
      };
    }
  }

  async getLocationByBrowser() {
    this.loadingMap = true;
    await this.geolocationService.getLocationByIp();
  }

  openWorkshopInfo(marker: MapMarker, workshop: WorkShopDTO) {
    this.analitycs.logEvent('el_usuario_abre_la_informacion_del_taller', {
      pantalla: 'mapa',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    this.selectedWorkshop = workshop;
    if (this.infoWindow) {
      this.infoWindow.open(marker);
    }
  }

  scrollToBottom(): void {
    setTimeout(() => {
      this.scrollable.scrollTo({ bottom: 0, duration: 200 });
    }, 300);
  }

  //   schedule(workShop: WorkShopDTO) {
  //     this.analitycs.logEvent('schedule an appointment with a workshop', {
  //       view: 'map',
  //       action: 'click',
  //       at: moment().format('YYYY-MM-DD HH:mm:ss'),
  //     });
  //comentado
  // if (this.coordinates.lat === 0 && this.coordinates.lng === 0) {
  //   this.router.navigate(['/assistant']);
  // } else {
  //   this.router.navigate(['/assistant'], { queryParams: { lat: this.coordinates.lat, lng: this.coordinates.lng } });
  // }
  // console.log('SELECTED', workShop);
  //hasta aqui
  //     this.assistantSchedule.emit(workShop);
  //   }

  // Método para actualizar los talleres con los recibidos del asistente
  schedule(workShop: WorkShopDTO) {
    this.analitycs.logEvent('el_usuario_agenda_cita_con_taller', {
      pantalla: 'mapa',
      accion: 'clic',
      plataforma: 'web',
      timestamp: new Date().toISOString(),
    });

    // Actualizar el ícono del taller seleccionado
    const foundIndex = this.workshops.findIndex((w) => w._id === workShop._id);
    if (foundIndex !== -1) {
      this.workshops[foundIndex].icon = WorkShopIconPositionFilteredConst;

      // Emitir el evento para actualizar en el mapa
      this.assistantSchedule.emit(workShop);
    }
  }
  updateWorkshops(workshopsData: any[]) {
    // this.analitycs.logEvent('update_workshops_from_assistant', {
    //   pantalla: 'mapa',
    //   accion: 'actualizar',
    //   plataforma: 'web',
    //   timestamp: new Date().toISOString(),
    // });

    // console.log('Actualizando talleres en el mapa:', workshopsData);

    // Procesar los talleres si no tienen las coordenadas en el formato correcto
    for (const workshop of workshopsData) {
      const found = this.workshops.findIndex((w) => w._id === workshop.id);
      //   console.log('FOUND', found);
      if (found !== -1) {
        this.workshops[found].icon = WorkShopIconPositionFilteredConst;
      }
    }
  }
}
